export default __webpack_public_path__ + "static/media/popCulture.51a7f972.jpeg";